import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import api from '../services/api';

const Tenants = () => {
  const [tenants, setTenants] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [editTenant, setEditTenant] = useState(null);
  const [formLoading, setFormLoading] = useState(false);
  const [success, setSuccess] = useState('');
  const [error, setError] = useState('');
  const [form, setForm] = useState({ name: '', code: '', ticket_prefix: '', type: 'isp', admin_name: '', admin_email: '', admin_phone: '', admin_password: '' });
  const [editForm, setEditForm] = useState({ name: '', type: 'isp' });
  const { tenant } = useAuth();
  const primaryColor = tenant ? tenant.branding.primary_color || '#1B6B3A' : '#1B6B3A';

  const loadTenants = () => {
    setLoading(true);
    api.get('/tenants').then(res => {
      setTenants(res.data.tenants);
    }).finally(() => setLoading(false));
  };

  useEffect(() => { loadTenants(); }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormLoading(true);
    setError('');
    setSuccess('');
    try {
      await api.post('/tenants', form);
      setSuccess('Created! Login: ' + form.admin_email + ' / ' + form.admin_password + ' / Code: ' + form.code.toUpperCase());
      setShowForm(false);
      setForm({ name: '', code: '', ticket_prefix: '', type: 'isp', admin_name: '', admin_email: '', admin_phone: '', admin_password: '' });
      loadTenants();
    } catch (err) {
      setError(err.response ? err.response.data.message : 'Failed to create');
    } finally { setFormLoading(false); }
  };

  const handleEdit = (t) => {
    setEditTenant(t);
    setEditForm({ name: t.name, type: t.type || 'isp' });
    setSuccess('');
    setError('');
  };

  const handleEditSubmit = async (e) => {
    e.preventDefault();
    setFormLoading(true);
    setError('');
    try {
      await api.put('/tenants/' + editTenant._id, editForm);
      setSuccess('Tenant updated successfully!');
      setEditTenant(null);
      loadTenants();
    } catch (err) {
      setError(err.response ? err.response.data.message : 'Failed to update');
    } finally { setFormLoading(false); }
  };

  const handleToggle = async (id) => {
    try {
      await api.put('/tenants/' + id + '/toggle');
      loadTenants();
    } catch (err) {
      alert('Failed to update tenant');
    }
  };

  const handleDelete = async (id, name) => {
    if (!window.confirm('DELETE "' + name + '"?\n\nThis will permanently delete ALL data!\n\nThis CANNOT be undone!')) return;
    try {
      await api.delete('/tenants/' + id);
      setSuccess(name + ' deleted successfully!');
      loadTenants();
    } catch (err) {
      setError(err.response ? err.response.data.message : 'Failed to delete');
    }
  };

  const handleLogoUpload = async (tenantId, file) => {
    if (!file) return;
    const formData = new FormData();
    formData.append('logo', file);
    try {
      await api.post('/tenants/' + tenantId + '/logo', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
      setSuccess('Logo uploaded successfully!');
      loadTenants();
    } catch (err) {
      setError('Failed to upload logo');
    }
  };

  const inputStyle = { width: '100%', padding: '10px 12px', border: '1px solid #ddd', borderRadius: '6px', fontSize: '14px', boxSizing: 'border-box' };
  const labelStyle = { display: 'block', marginBottom: '6px', color: '#333', fontSize: '14px', fontWeight: '500' };
  const typeColor = { isp: { bg: '#e3f2fd', color: '#1565c0', label: 'ISP' }, distributor: { bg: '#f3e5f5', color: '#7b1fa2', label: 'Distributor' } };

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
        <h2 style={{ margin: '0', color: '#333' }}>ISP / Distributor Management ({tenants.length})</h2>
        <button onClick={() => { setShowForm(!showForm); setEditTenant(null); setSuccess(''); setError(''); }} style={{ background: primaryColor, color: 'white', border: 'none', padding: '10px 20px', borderRadius: '6px', cursor: 'pointer', fontWeight: '600' }}>
          {showForm ? 'Cancel' : '+ Add New'}
        </button>
      </div>
      {success && <div style={{ background: '#e8f5e9', color: '#2e7d32', padding: '16px', borderRadius: '8px', marginBottom: '16px', fontWeight: '500' }}>✅ {success}</div>}
      {error && <div style={{ background: '#ffebee', color: '#c62828', padding: '12px', borderRadius: '6px', marginBottom: '16px' }}>{error}</div>}
      {editTenant && (
        <div style={{ background: 'white', borderRadius: '10px', boxShadow: '0 2px 10px rgba(0,0,0,0.08)', padding: '24px', marginBottom: '20px', border: '2px solid #ff9800' }}>
          <h3 style={{ margin: '0 0 20px', color: '#e65100' }}>Edit — {editTenant.name}</h3>
          <form onSubmit={handleEditSubmit}>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginBottom: '20px' }}>
              <div>
                <label style={labelStyle}>Organization Name *</label>
                <input type="text" value={editForm.name} onChange={e => setEditForm({...editForm, name: e.target.value})} required style={inputStyle} />
              </div>
              <div>
                <label style={labelStyle}>Type *</label>
                <div style={{ display: 'flex', gap: '12px' }}>
                  <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', padding: '10px 16px', border: '2px solid ' + (editForm.type === 'isp' ? '#1565c0' : '#ddd'), borderRadius: '6px', flex: 1, background: editForm.type === 'isp' ? '#e3f2fd' : 'white' }}>
                    <input type="radio" name="edittype" value="isp" checked={editForm.type === 'isp'} onChange={e => setEditForm({...editForm, type: e.target.value})} />
                    <span style={{ fontWeight: '600', color: editForm.type === 'isp' ? '#1565c0' : '#333' }}>ISP</span>
                  </label>
                  <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', padding: '10px 16px', border: '2px solid ' + (editForm.type === 'distributor' ? '#7b1fa2' : '#ddd'), borderRadius: '6px', flex: 1, background: editForm.type === 'distributor' ? '#f3e5f5' : 'white' }}>
                    <input type="radio" name="edittype" value="distributor" checked={editForm.type === 'distributor'} onChange={e => setEditForm({...editForm, type: e.target.value})} />
                    <span style={{ fontWeight: '600', color: editForm.type === 'distributor' ? '#7b1fa2' : '#333' }}>Distributor</span>
                  </label>
                </div>
                <p style={{ margin: '6px 0 0', fontSize: '12px', color: '#e65100' }}>Changing type updates admin role automatically!</p>
              </div>
            </div>
            <div style={{ flex: 'flex', gap: '12px' }}>
              <button type="submit" disabled={formLoading} style={{ padding: '10px 24px', background: formLoading ? '#ccc' : '#ff9800', color: 'white', border: 'none', borderRadius: '6px', cursor: formLoading ? 'not-allowed' : 'pointer', fontWeight: '600', marginRight: '12px' }}>{formLoading ? 'Saving...' : 'Save Changes'}</button>
              <button type="button" onClick={() => setEditTenant(null)} style={{ padding: '10px 24px', background: 'white', color: '#333', border: '1px solid #ddd', borderRadius: '6px', cursor: 'pointer' }}>Cancel</button>
            </div>
          </form>
        </div>
      )}
      {showForm && (
        <div style={{ background: 'white', borderRadius: '10px', boxShadow: '0 2px 10px rgba(0,0,0,0.08)', padding: '24px', marginBottom: '20px' }}>
          <h3 style={{ margin: '0 0 20px', color: primaryColor }}>Create New ISP / Distributor</h3>
          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom: '20px', padding: '16px', background: '#f9f9f9', borderRadius: '8px' }}>
              <h4 style={{ margin: '0 0 16px', color: '#333' }}>Organization Details</h4>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginBottom: '16px' }}>
                <div>
                  <label style={labelStyle}>Type *</label>
                  <div style={{ display: 'flex', gap: '12px' }}>
                    <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', padding: '10px 16px', border: '2px solid ' + (form.type === 'isp' ? '#1565c0' : '#ddd'), borderRadius: '6px', flex: 1, background: form.type === 'isp' ? '#e3f2fd' : 'white' }}>
                      <input type="radio" name="type" value="isp" checked={form.type === 'isp'} onChange={e => setForm({...form, type: e.target.value})} />
                      <span style={{ fontWeight: '600', color: form.type === 'isp' ? '#1565c0' : '#333' }}>ISP</span>
                    </label>
                    <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', padding: '10px 16px', border: '2px solid ' + (form.type === 'distributor' ? '#7b1fa2' : '#ddd'), borderRadius: '6px', flex: 1, background: form.type === 'distributor' ? '#f3e5f5' : 'white' }}>
                      <input type="radio" name="type" value="distributor" checked={form.type === 'distributor'} onChange={e => setForm({...form, type: e.target.value})} />
                      <span style={{ fontWeight: '600', color: form.type === 'distributor' ? '#7b1fa2' : '#333' }}>Distributor</span>
                    </label>
                  </div>
                  <p style={{ margin: '6px 0 0', fontSize: '12px', color: '#666' }}>{form.type === 'isp' ? 'ISP → Distribution → Sub Distribution → LCO' : 'Distributor → Sub Distribution → LCO'}</p>
                </div>
                <div>
                  <label style={labelStyle}>Organization Name *</label>
                  <input type="text" placeholder="e.g. ABC Broadband" value={form.name} onChange={e => setForm({...form, name: e.target.value})} required style={inputStyle} />
                </div>
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                <div>
                  <label style={labelStyle}>Unique Code *</label>
                  <input type="text" placeholder="e.g. ABC" value={form.code} onChange={e => setForm({...form, code: e.target.value.toUpperCase()})} required maxLength={10} style={inputStyle} />
                  <p style={{ margin: '4px 0 0', fontSize: '12px', color: '#666' }}>Used for login — must be unique</p>
                </div>
                <div>
                  <label style={labelStyle}>Ticket Prefix</label>
                  <input type="text" placeholder="e.g. ABC" value={form.ticket_prefix} onChange={e => setForm({...form, ticket_prefix: e.target.value.toUpperCase()})} maxLength={5} style={inputStyle} />
                  <p style={{ margin: '4px 0 0', fontSize: '12px', color: '#666' }}>Tickets: {form.ticket_prefix || form.code || 'ABC'}-2026-00001</p>
                </div>
              </div>
            </div>
            <div style={{ marginBottom: '20px', padding: '16px', background: '#f0fff4', borderRadius: '8px' }}>
              <h4 style={{ margin: '0 0 16px', color: primaryColor }}>Admin Login Details</h4>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginBottom: '16px' }}>
                <div><label style={labelStyle}>Admin Full Name *</label><input type="text" placeholder="Admin name" value={form.admin_name} onChange={e => setForm({...form, admin_name: e.target.value})} required style={inputStyle} /></div>
                <div><label style={labelStyle}>Admin Phone *</label><input type="text" placeholder="Mobile number" value={form.admin_phone} onChange={e => setForm({...form, admin_phone: e.target.value})} required style={inputStyle} /></div>
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                <div><label style={labelStyle}>Admin Email *</label><input type="email" placeholder="Admin email" value={form.admin_email} onChange={e => setForm({...form, admin_email: e.target.value})} required style={inputStyle} /></div>
                <div><label style={labelStyle}>Admin Password *</label><input type="text" placeholder="Set initial password" value={form.admin_password} onChange={e => setForm({...form, admin_password: e.target.value})} required style={inputStyle} /><p style={{ margin: '4px 0 0', fontSize: '12px', color: '#e65100' }}>Share this with the admin!</p></div>
              </div>
            </div>
            <button type="submit" disabled={formLoading} style={{ padding: '12px 32px', background: formLoading ? '#ccc' : primaryColor, color: 'white', border: 'none', borderRadius: '6px', fontSize: '15px', fontWeight: '600', cursor: formLoading ? 'not-allowed' : 'pointer' }}>
              {formLoading ? 'Creating...' : 'Create ' + (form.type === 'isp' ? 'ISP' : 'Distributor')}
            </button>
          </form>
        </div>
      )}
      <div style={{ background: 'white', borderRadius: '10px', boxShadow: '0 2px 10px rgba(0,0,0,0.08)', overflow: 'hidden' }}>
        {loading ? <p style={{ padding: '20px', textAlign: 'center' }}>Loading...</p> : (
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ background: primaryColor }}>
                <th style={{ padding: '12px', textAlign: 'left', fontSize: '13px', color: 'white' }}>Organization</th>
                <th style={{ padding: '12px', textAlign: 'left', fontSize: '13px', color: 'white' }}>Type</th>
                <th style={{ padding: '12px', textAlign: 'left', fontSize: '13px', color: 'white' }}>Code</th>
                <th style={{ padding: '12px', textAlign: 'left', fontSize: '13px', color: 'white' }}>Ticket Prefix</th>
                <th style={{ padding: '12px', textAlign: 'left', fontSize: '13px', color: 'white' }}>App Name</th>
                <th style={{ padding: '12px', textAlign: 'left', fontSize: '13px', color: 'white' }}>Status</th>
                <th style={{ padding: '12px', textAlign: 'left', fontSize: '13px', color: 'white' }}>Created</th>
                <th style={{ padding: '12px', textAlign: 'left', fontSize: '13px', color: 'white' }}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {tenants.length === 0 ? (
                <tr><td colSpan="8" style={{ padding: '20px', textAlign: 'center', color: '#666' }}>No tenants found</td></tr>
              ) : tenants.map(function(t) {
                const tType = typeColor[t.type] || typeColor['isp'];
                return (
                  <tr key={t._id} style={{ borderBottom: '1px solid #f0f0f0' }}>
                    <td style={{ padding: '12px' }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        {t.branding.logo_url ? (
                          <img src={'https://desk.fibralink.co.in' + t.branding.logo_url} alt="logo" style={{ width: '48px', height: '36px', objectFit: 'contain', borderRadius: '4px', border: '1px solid #eee' }} />
                        ) : (
                          <div style={{ width: '36px', height: '36px', background: t.branding.primary_color || primaryColor, borderRadius: '4px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', fontSize: '12px', fontWeight: '700' }}>{t.name.charAt(0)}</div>
                        )}
                        <strong style={{ fontSize: '13px' }}>{t.name}</strong>
                      </div>
                    </td>
                    <td style={{ padding: '12px' }}><span style={{ background: tType.bg, color: tType.color, padding: '4px 10px', borderRadius: '4px', fontSize: '12px', fontWeight: '700' }}>{tType.label}</span></td>
                    <td style={{ padding: '12px' }}><span style={{ background: '#e3f2fd', color: '#1565c0', padding: '4px 10px', borderRadius: '4px', fontSize: '13px', fontWeight: '700' }}>{t.code}</span></td>
                    <td style={{ padding: '12px', fontSize: '13px', fontWeight: '600', color: primaryColor }}>{t.ticket_prefix}-XXXX</td>
                    <td style={{ padding: '12px', fontSize: '13px' }}>{t.branding.app_name}</td>
                    <td style={{ padding: '12px' }}><span style={{ background: t.is_active ? '#4caf5020' : '#f4433620', color: t.is_active ? '#4caf50' : '#f44336', padding: '3px 8px', borderRadius: '4px', fontSize: '12px', fontWeight: '600' }}>{t.is_active ? 'Active' : 'Inactive'}</span></td>
                    <td style={{ padding: '12px', fontSize: '12px', color: '#666' }}>{new Date(t.createdAt).toLocaleDateString()}</td>
                    <td style={{ padding: '12px' }}>
                      <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap' }}>
                        <button onClick={() => handleEdit(t)} style={{ background: '#ff980020', color: '#e65100', border: 'none', padding: '5px 10px', borderRadius: '4px', cursor: 'pointer', fontSize: '12px', fontWeight: '600' }}>Edit</button>
                        <label style={{ background: '#e3f2fd', color: '#1565c0', border: 'none', padding: '5px 10px', borderRadius: '4px', cursor: 'pointer', fontSize: '12px', fontWeight: '600' }}>
                          Logo
                          <input type="file" accept="image/*" onChange={e => handleLogoUpload(t._id, e.target.files[0])} style={{ display: 'none' }} />
                        </label>
                        <button onClick={() => handleToggle(t._id)} style={{ background: t.is_active ? '#f4433620' : '#4caf5020', color: t.is_active ? '#f44336' : '#4caf50', border: 'none', padding: '5px 10px', borderRadius: '4px', cursor: 'pointer', fontSize: '12px', fontWeight: '600' }}>{t.is_active ? 'Deactivate' : 'Activate'}</button>
                        <button onClick={() => handleDelete(t._id, t.name)} style={{ background: '#ffebee', color: '#c62828', border: 'none', padding: '5px 10px', borderRadius: '4px', cursor: 'pointer', fontSize: '12px', fontWeight: '600' }}>Delete</button>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default Tenants;
